'use strict'

let organization=require('../../organization/labels/norwegian.js').norwegian;
let risk=require('../../risk/labels/norwegian.js').norwegian;
let quality=require('../../quality/labels/norwegian.js').norwegian;
let change=require('../../change/labels/norwegian.js').norwegian;
let plan=require('../../plan/labels/norwegian.js').norwegian;

export let norwegian={
  communication: {
    title: "Tilnærming til kommunikasjon",
    process: organization.communicationManagementApproach.fields.process.title,
    tools: organization.communicationManagementApproach.fields.tools.title,
    reporting: organization.communicationManagementApproach.fields.reporting.title,
    timing: organization.communicationManagementApproach.fields.timing.title,
    roles: organization.communicationManagementApproach.fields.roles.title,
    stakeholderCommunication: {
      title: organization.stakeholderAnalysis.fields.stakeholders.title,
      columns: organization.stakeholderAnalysis.fields.stakeholders.columns
    }
  },
  risk: {
    title: risk.riskManagementApproach.title,
    process: risk.riskManagementApproach.fields.process.title,
    tools: risk.riskManagementApproach.fields.tools.title,
    reporting: risk.riskManagementApproach.fields.reporting.title,
    timing: risk.riskManagementApproach.fields.timing.title,
    roles: risk.riskManagementApproach.fields.roles.title,
    tolerance: risk.riskManagementApproach.fields.tolerance.title,
    budget: risk.riskManagementApproach.fields.budget.title
  },
  quality: {
    title: quality.qualityManagementApproach.title,
    process: quality.qualityManagementApproach.fields.process.title,
    tools: quality.qualityManagementApproach.fields.tools.title,
    reporting: quality.qualityManagementApproach.fields.reporting.title,
    timing: quality.qualityManagementApproach.fields.timing.title,
    roles: quality.qualityManagementApproach.fields.roles.title
  },
  change: {
    title: change.changeControlApproach.title,
    process: change.changeControlApproach.fields.process.title,
    tools: change.changeControlApproach.fields.tools.title,
    reporting: change.changeControlApproach.fields.reporting.title,
    timing: change.changeControlApproach.fields.timing.title,
    roles: change.changeControlApproach.fields.roles.title,
    scales: change.changeControlApproach.fields.scales.title
  },
  plan: {
    projectControls: {
      title: plan.projectControls.title
    },
    schedule: {
      title: "Prosjektplan"
    }
  },
  pid: {
    title: "Styringsdokument"
  },
  approval: {
    approve: "Godkjenn styringsdokumentet"
  }
}



// WEBPACK FOOTER //
// ./views/pid/labels/norwegian.js